module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapterno"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('b', [_vm._v("4")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("EVALUATING CUSTOMER COMPLAINTS.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My subscriber SM was confused or possibly upset by my endorsement of the AWAI copywriting course:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "underline"
  })]), _c('a', {
    attrs: {
      "href": "http://www.thewriterslife.com/bobrecommends",
      "target": "_blank"
    }
  }, [_vm._v("http://www.thewriterslife.com/bobrecommends")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The source of her consternation was her finding a discussion board where a contributor bashed the AWAI course and me for recommending it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You happen to be one of the top names out there, and your opinion counts,” SM wrote me. “This got me pretty confused.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My message to SM is: there’s nothing to be confused about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You know the old saying: “You can’t please all of the people, all of the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("SM seems to have forgotten it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My friend, motivational speaker Rob Gilbert, has a formula that encapsulates this maxim:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("SWL + SWNL = SW")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This stands for:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Some will like you, your services, or your products. Some will not like you, your services, or your products. So what?”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("You cannot control people’s preferences, tastes, and beliefs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All you can do as a marketer or service provider is to work diligently to find out what people want from you … and then tailor your products or services to deliver it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even then, you will not please all of the people, all of the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet SM seems to think you can and must.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw many positive reviews upon research, and this one negative review (admittedly only one), just knocked it all out,” she writes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That makes no sense to me, because it’s to be expected that some will like you, your services, or your products — and some will not like you, your services, or your products.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why would SM think otherwise?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My advice for interpreting criticism, ratings, or reviews: throw away the worst review and the best review, and take the average of the rest as your true ranking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I do this when evaluating my performance in giving seminars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the evaluation, I ask the attendees to rate me on a scale of 1 to 5, with 1 = low and 5 = high.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mentally, I disregard the highest score and the lowest score.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I throw out the best evaluation because there are some people out there who seem to be rabid fans of your stuff beyond what is rational: they just love whatever you do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I throw out the worst review because there are some people who hold an almost irrational grudge against you: they hate your voice, your face, your ethnicity, your philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At one seminar an attendee gave me a bad rating because he thought my shoes were not highly polished enough. I am not making this up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(Years later I was at a Toastmasters event where one of the club members, giving a talk on how to succeed in business, said that one of the most important factors was to wear expensive shoes that are well polished.)")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("You may want to go through a similar process when evaluating any set of critiques, reviews, or comments; i.e., Amazon stars for a book, a debate on a bulletin board, e-mail from product purchasers.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It will give you a more accurate and reasonable assessment of the quality of the item under discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One critic on the anti-AWAI discussion board gave this advice: “Any time you are thinking of taking a course, type the course name into Google followed by the word ‘scam’ and see what comes up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is terrible advice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reason: any time a really successful person offers to sell advice on how to duplicate his success, it raises the ire of envious and skeptical people who believe such a thing just can’t be so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reason for their skepticism is often that the results the marketing promises — and the author and his students have actually achieved — are just so far beyond the readers’ experience that they simply cannot believe it is true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Subscribers often ask me, “Can’t people just put fake testimonials on their Web sites?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course they can, but most don’t, because it’s not only unethical but also illegal, and the penalties are stiff if you get caught.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208bf128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/13_ch4.vue
// module id = 93
// module chunks = 0